import axios from "./axios";

export const resetPassword = async (oldPassword, newPassword) => {
  const response = await axios.post("/users/reset-password", {
    oldPassword,
    newPassword,
  });
  return response.data;
};

export const getSellerStats = async () => {
  const response = await axios.get("/users/seller-stats");
  return response.data;
};

export const updateSellerStats = async (data) => {
  const response = await axios.put("/users/seller-stats", data);
  return response.data;
};

export const getEmployerStats = async () => {
  const response = await axios.get("/users/employer-stats");
  return response.data;
};

export const updateEmployerStats = async (data) => {
  const response = await axios.put("/users/employer-stats", data);
  return response.data;
};

/**
 * Saves location on the user record only if not already set (backend guards this too).
 * @param {{ longitude, latitude, city, country, state }} locationData
 */
export const saveLocationIfMissing = async (locationData) => {
  const response = await axios.post("/users/save-location", locationData);
  return response.data;
};
